import TagSearch from "./tagSearch.container";

export default TagSearch;